module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader' || _vm.researchGroupCharacter === 'approver') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("审批订单")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.waitApproveOrderList), function(order, index) {
    return _c('router-link', {
      key: index,
      staticClass: "bd",
      attrs: {
        "to": {
          name: 'ApproveOrderDetail',
          query: {
            researchGroupNo: _vm.researchGroupNo,
            orderNo: order.orderNo
          }
        }
      }
    }, [_c('div', {
      staticClass: "outer"
    }, [_c('span', {
      staticClass: "info"
    }, [_vm._v("下单成员：" + _vm._s(order.orderPerson))]), _vm._v(" "), _c('div', {
      staticClass: "tagWrap"
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v("未审批")])])]), _vm._v(" "), _c('div', {
      staticClass: "block"
    }, [_c('span', {
      staticClass: "orderTime"
    }, [_vm._v("下单时间：" + _vm._s(order.orderTime))]), _vm._v(" "), _c('svg', {
      staticClass: "liveiconput",
      attrs: {
        "t": "1583809028111",
        "viewBox": "0 0 1024 1024",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "p-id": "1461",
        "width": "200",
        "height": "200"
      }
    }, [_c('path', {
      attrs: {
        "d": "M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z",
        "fill": "#929292",
        "p-id": "1462"
      }
    })])]), _vm._v(" "), _c('span', {
      staticClass: "orderNumber"
    }, [_vm._v("订单编号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("订单总金额：¥" + _vm._s(_vm.splitMoney(order.price)))])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "7vw",
      "visibility": "hidden"
    }
  }, [_vm._v("white")])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0a07dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupManagement/ApproveOrder.vue
// module id = 1529
// module chunks = 8